(function () {
  const SCROLL_DOWN_THRESHOLD = 56;
  const SCROLL_UP_THRESHOLD = 12;

  function initHeaderLogoScroll() {
    const header = document.querySelector('store-header.header');
    if (!header) return;

    let scheduled = false;
    let isScrolled = window.scrollY > SCROLL_DOWN_THRESHOLD;

    const update = () => {
      const scrollY = window.scrollY;

      if (!isScrolled && scrollY > SCROLL_DOWN_THRESHOLD) {
        isScrolled = true;
      } else if (isScrolled && scrollY < SCROLL_UP_THRESHOLD) {
        isScrolled = false;
      }

      header.classList.toggle('is-scrolled', isScrolled);
    };

    const scheduleUpdate = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        update();
      });
    };

    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('pageshow', update);

    if (window.lenis && typeof window.lenis.on === 'function') {
      window.lenis.on('scroll', scheduleUpdate);
    }

    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderLogoScroll, { once: true });
  } else {
    initHeaderLogoScroll();
  }
})();
